import {
  TasksValueObjectsTaskCategoryEnum,
  TasksValueObjectsTaskCategoryEnumValues,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

export const getTaskCategoryEnumValues = (): TasksValueObjectsTaskCategoryEnum[] => [
  ...TasksValueObjectsTaskCategoryEnumValues,
]

export const TASK_CATEGORY_TRANSLATIONS: Record<TasksValueObjectsTaskCategoryEnum, () => string> = {
  compensation: () => i18n.t('sidebar.compensation'),
  benefits: () => i18n.t('benefits.module_name'),
  complaints: () => i18n.t('sidebar.complaints'),
  documents: () => i18n.t('sidebar.documents'),
  engagement: () => i18n.t('sidebar.engagement'),
  finance: () => i18n.t('sidebar.finance'),
  policies: () => i18n.t('sidebar.policies'),
  recruitment: () => i18n.t('sidebar.recruitment'),
  organization: () => i18n.t('sidebar.team'),
  performance: () => i18n.t('sidebar.performance_new'),
  software: () => i18n.t('finance.modules.spending.software'),
  spending: () => i18n.t('sidebar.finance_spending'),
  surveys: () => i18n.t('surveys.title'),
  time_planning: () => i18n.t('sidebar.shift_management'),
  time_tracking: () => i18n.t('sidebar.time_tracking'),
  timeoff: () => i18n.t('sidebar.time_off'),
  training: () => i18n.t('sidebar.trainings'),
}
